import { useMemo } from 'react';
import type { CatalogItem } from '../../../../../../redux/api/fymAPI.types';
import { useMusic24Capabilities } from '../../../../hooks/useMusic24Capabilities';
import { utcToday } from '../../frames/studioStory';
import type { SongTheme } from '../../useSongTheme';
import type { StudioSongFacts } from '../props';
import type { StoryPreviewContext } from './storyPreviewContext';

/** The facts of the drawn image previews of step 3: the song, its theme and the Free watermark. */
export function useStoryPreviewContext(
  item: CatalogItem,
  song: StudioSongFacts,
  songTheme: SongTheme,
  artworkUrl: string | undefined
): StoryPreviewContext {
  const { clipWatermark } = useMusic24Capabilities();
  return useMemo(
    () => ({
      look: songTheme.look,
      palette: songTheme.palette,
      artworkUrl,
      logoUrl: songTheme.kit?.logoUrl ?? null,
      title: item.title,
      artist: item.artistName,
      // The render reads the release date of the Story answer; the catalog row has the same day.
      releaseDate: songTheme.storyReleaseDate ?? item.releaseDate?.slice(0, 10) ?? null,
      daysToRelease: song.daysToRelease,
      lyrics: song.lyrics,
      link: songTheme.storyLink,
      presave: songTheme.storyPresave,
      watermark: clipWatermark,
      today: utcToday(),
      locale: songTheme.storyLocale,
    }),
    [artworkUrl, clipWatermark, item, song.daysToRelease, song.lyrics, songTheme]
  );
}
